import { RecursoSiconfi } from 'eddydata-lib';
import { BaseResourceModel } from '../../models/base-resource.model';
import { Exercicio } from '../comum/exercicio.model';

export class RecursoSiconfiAnterior extends BaseResourceModel {
  constructor(
    public id?: number,
    public recurso_siconfi_anterior?: RecursoSiconfi,
    public recurso_siconfi_atual?: RecursoSiconfi,
    public exercicio?: Exercicio) {
    super();
  }
  static converteJson(json: any): RecursoSiconfiAnterior {
    return Object.assign(new RecursoSiconfiAnterior(), json);
  }
}